export enum EnumDouleurPsychiqueStat {
  Fatigue = "FATIGUE",
  Anxiete = "ANXIETE",
  TroublesDuSommeil = "TROUBLES_DU_SOMMEIL",
  SyndromeDepressif = "SYNDROME_DEPRESSIF",
  Autre = "AUTRE"
}
